export default __webpack_public_path__ + "static/media/V365_RoHS.c22191b9.pdf";